import { StoryPreview } from '@/components/StoryPreview';
import { Button } from '@/components/ui/button';
import type { GeneratedStory } from 'schemas';
import { createStoryPageMessages } from '../../createStoryPage.messages';
import { sharedMessages } from '@/shared-messages/shared.messages';

interface StoryPreviewStepProps {
  generatedStory: GeneratedStory | null;
  onBack: () => void;
  onNext: () => void;
}

export function StoryPreviewStep({
  generatedStory,
  onBack,
  onNext,
}: StoryPreviewStepProps) {
  if (!generatedStory) {
    return null;
  }

  return (
    <div className="space-y-8">
      <StoryPreview
        title={generatedStory.title}
        spreads={generatedStory.spreads}
        showFinalEntryCta={true}
      />

      <div className="flex justify-between pt-4">
        <Button
          variant="secondary"
          onClick={onBack}
          aria-label={sharedMessages.commonButtons.back}
        >
          {sharedMessages.commonButtons.back}
        </Button>
        <Button onClick={onNext} aria-label="Go to checkout">
          {createStoryPageMessages.checkoutCtaButton}
        </Button>
      </div>
    </div>
  );
}
